import { CircularProgress } from '@mui/material'

export const Progress = () => (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
    <CircularProgress />
  </div>
)
